import React from "react";
import Reveal from "./Reveal";

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="wrap">
        <div className="hero-grid">
          <Reveal>
            <div className="badge-alert">🚨 PhD Deadline Alert</div>
            <h1>
              Running out of time <em>on your thesis?</em>
            </h1>
            <p className="lead">
              We deliver expert PhD support for every stage — from research
              to publication. Trusted by 15,000+ scholars across Engineering,
              Medical, Law, Commerce & more.
            </p>
            <div className="hero-ctas">
              <a href="#contact" className="btn btn-gold">
                Get Free Consultation →
              </a>
              <a
                href="#services"
                className="btn btn-outline"
                style={{ color: "#fff", borderColor: "rgba(255,255,255,.5)" }}
              >
                View Services
              </a>
            </div>
            <div className="stat-row">
              <div className="stat">
                <span className="num">15K+</span>
                <span className="lab">Scholars Guided</span>
              </div>
              <div className="stat">
                <span className="num">4.9★</span>
                <span className="lab">Google Rating</span>
              </div>
              <div className="stat">
                <span className="num">30%</span>
                <span className="lab">Off — Limited</span>
              </div>
            </div>
          </Reveal>

          <Reveal>
            <div className="hero-card">
              <div className="pin">30% OFF · Ends Soon</div>
              <p className="quote">
                No mismatch. No rejections. No wasted months.
              </p>
              <p style={{ fontSize: ".92rem", color: "var(--ink-soft)", marginBottom: 0 }}>
                We serve scholars across every discipline —
              </p>
              <div className="tag-cloud">
                {[
                  "Engineering", "Management", "Life Sciences", "Physical Sciences",
                  "Law", "Arts", "Medical", "Commerce", "Technology",
                ].map((tag) => (
                  <span key={tag}>{tag}</span>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
